var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.menuIngredients,"search":_vm.searchText,"role":"button","sort-by":"name","dense":""},on:{"click:row":_vm.add},scopedSlots:_vm._u([{key:"item.price",fn:function({ item }){return [_c('span',[_vm._v(_vm._s(_vm._f("currency")(item.price)))])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }